import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import React, { useContext, useRef, useState, useEffect } from 'react';
import { hooks } from '../../../config/api';
import PropTypes from 'prop-types';
import { TrackerContext } from '@unite-us/client-utils';
import { Button, Dialog } from '@unite-us/ui';
import { FACESHEET } from '../../../constants/eventConstants';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import AddCirclePlusButton from '../../common/AddCirclePlusButton';
import { PrimaryButton, SecondaryButton } from '../../common/TailwindComponents';
import { useSocialInsurancePlanOptions, useCreateSocialInsurance } from '../hooks';
import { initiateSocialCoverageEventTracking } from '../utils/initiateSocialCoverageEventTracking';
import { SocialInsuranceFields } from './SocialInsuranceFields';
import Spinner from '../../common/spinners/Spinner';
export var SocialInsuranceForm = function SocialInsuranceForm(_ref) {
  var _contact$consent, _selectedPlan$require, _data$data, _provider$payer;
  var contact = _ref.contact,
    goToEnrollmentWorkflow = _ref.goToEnrollmentWorkflow,
    groupId = _ref.groupId,
    networkId = _ref.networkId;
  var contactId = contact.id;
  var clientHasConsent = ((_contact$consent = contact.consent) === null || _contact$consent === void 0 ? void 0 : _contact$consent.state) === 'accepted';
  var hasEnrollments = useFeatureFlag('enrollment-wq');
  var isStartDateRequired = useFeatureFlag('pays-2525-temp-scc-start-at');
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    planId = _useState2[0],
    setPlanId = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    primaryInsuranceId = _useState4[0],
    setPrimaryInsuranceId = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    startDateInEpochSeconds = _useState6[0],
    setStartDateInEpochSeconds = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    endDateInEpochSeconds = _useState8[0],
    setEndDateInEpochSeconds = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    disableEnrollment = _useState10[0],
    setDisableEnrollment = _useState10[1];
  var socialInsuranceAddModalRef = useRef(null);
  var unsavedChangesModalRef = useRef(null);
  var continueEnrollmentModalRef = useRef(null);
  var _useSocialInsurancePl = useSocialInsurancePlanOptions({
      providerId: groupId,
      networkId: networkId,
      contactId: contactId,
      hasEnrollments: hasEnrollments
    }),
    planOptions = _useSocialInsurancePl.planOptions,
    loadPlanOptions = _useSocialInsurancePl.loadPlanOptions;
  var invalidateQueries = hooks.useInvalidateQueries();
  var createSocialInsurance = useCreateSocialInsurance(contactId);
  var selectedPlan = _findInstanceProperty(planOptions).call(planOptions, function (plan) {
    return plan.id === planId;
  });
  var isEnrollmentRequired = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.enrollment_required;
  var submitButtonLabel = hasEnrollments && isEnrollmentRequired ? 'Next' : 'Save';
  var doesPlanRequireHealthInsurance = (selectedPlan === null || selectedPlan === void 0 || (_selectedPlan$require = selectedPlan.required_health_plans) === null || _selectedPlan$require === void 0 ? void 0 : _selectedPlan$require.length) > 0;
  var _hooks$useFindRecord = hooks.useFindRecord("provider", groupId, {
      queryConfig: {
        placeholderData: undefined,
        enabled: !!groupId
      }
    }),
    data = _hooks$useFindRecord.data,
    isLoading = _hooks$useFindRecord.isLoading;
  var provider = (data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.data) || {};
  var providerPayer = (_provider$payer = provider.payer) === null || _provider$payer === void 0 ? void 0 : _provider$payer.id;
  var isSamePayer = (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.payer.id) === providerPayer;
  useEffect(function () {
    var _selectedPlan$require2;
    if ((selectedPlan === null || selectedPlan === void 0 || (_selectedPlan$require2 = selectedPlan.required_health_plans) === null || _selectedPlan$require2 === void 0 ? void 0 : _selectedPlan$require2.length) === 0) setPrimaryInsuranceId(undefined);
  }, [planId]);
  var onContinueEnrollment = function onContinueEnrollment() {
    goToEnrollmentWorkflow(planId, primaryInsuranceId);
  };
  var eventTracker = useContext(TrackerContext);
  var openContinueEnrollmentModal = function openContinueEnrollmentModal() {
    continueEnrollmentModalRef.current.openDialog();
  };
  var clickXContinueEnrollmentActions = function clickXContinueEnrollmentActions() {
    continueEnrollmentModalRef.current.closeDialog();
    unsavedChangesModalRef.current.openDialog();
  };
  var openUnsavedChangesModal = function openUnsavedChangesModal() {
    unsavedChangesModalRef.current.openDialog();
  };
  var openSocialInsuranceModal = function openSocialInsuranceModal() {
    socialInsuranceAddModalRef.current.openDialog();
  };
  var closeModal = function closeModal() {
    setPlanId('');
    setPrimaryInsuranceId(undefined);
    setStartDateInEpochSeconds('');
    setEndDateInEpochSeconds('');
    setDisableEnrollment(false);
    socialInsuranceAddModalRef.current.closeDialog();
    unsavedChangesModalRef.current.closeDialog();
    invalidateQueries('insurance');
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            initiateSocialCoverageEventTracking({
              eventTracker: eventTracker,
              eventName: FACESHEET.insuranceChanged
            });
            _context.next = 3;
            return createSocialInsurance({
              planId: planId,
              startDateInEpochSeconds: startDateInEpochSeconds,
              endDateInEpochSeconds: endDateInEpochSeconds,
              primaryInsuranceId: primaryInsuranceId
            });
          case 3:
            closeModal();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  return isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement("div", {
    className: "section-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "add-insurance-information__section"
  }, /*#__PURE__*/React.createElement(AddCirclePlusButton, {
    addHandler: openSocialInsuranceModal,
    id: "add-social-insurance-button",
    labelText: "Add Social Care Coverage"
  })), /*#__PURE__*/React.createElement(Dialog, {
    id: "add-social-care-modal",
    ref: socialInsuranceAddModalRef,
    title: "Add Social Care Coverage",
    modal: true,
    onRequestClose: openUnsavedChangesModal,
    "data-testid": "add-social-care-modal",
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SecondaryButton, {
      className: "action-item",
      label: "Cancel",
      "data-testid": "add-scc-modal-cancel-button",
      onClick: openUnsavedChangesModal
    }), /*#__PURE__*/React.createElement(PrimaryButton, {
      className: "action-item",
      onClick: isEnrollmentRequired ? openContinueEnrollmentModal : onSubmit,
      label: submitButtonLabel,
      "data-testid": "add-scc-modal-next-button",
      disabled: !(planId && (!isStartDateRequired || startDateInEpochSeconds)) || isEnrollmentRequired && !clientHasConsent && !isSamePayer || disableEnrollment || doesPlanRequireHealthInsurance && !primaryInsuranceId
    }))
  }, /*#__PURE__*/React.createElement("form", {
    "data-testid": "social-insurance-form",
    className: "content-with-actions"
  }, /*#__PURE__*/React.createElement(SocialInsuranceFields, {
    planIdTuple: [planId, setPlanId],
    startDateTuple: [startDateInEpochSeconds, setStartDateInEpochSeconds],
    endDateTuple: [endDateInEpochSeconds, setEndDateInEpochSeconds],
    primaryInsuranceIdTuple: [primaryInsuranceId, setPrimaryInsuranceId],
    disableEnrollmentTuple: [disableEnrollment, setDisableEnrollment],
    planOptions: planOptions,
    loadPlanOptions: loadPlanOptions,
    isStartDateRequired: isStartDateRequired,
    clientHasConsent: clientHasConsent,
    isSamePayer: isSamePayer,
    contactId: contactId
  }))), /*#__PURE__*/React.createElement(Dialog, {
    id: "unsaved-changes-dialog",
    className: "sub-dialog",
    ref: unsavedChangesModalRef,
    title: "Unsaved Changes",
    modal: true,
    onRequestClose: function onRequestClose() {
      return unsavedChangesModalRef.current.closeDialog();
    },
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      label: "Back",
      onClick: function onClick() {
        return unsavedChangesModalRef.current.closeDialog();
      }
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: closeModal,
      primary: true,
      label: "Exit"
    }))
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "pb-4"
  }, "If you exit now, this Social Care Coverage plan will not be saved to your client\u2019s profile."), /*#__PURE__*/React.createElement("p", {
    className: "pb-4"
  }, "Are you sure you want to exit?"))), /*#__PURE__*/React.createElement(Dialog, {
    id: "continue-enrollment-dialog",
    className: "sub-dialog",
    ref: continueEnrollmentModalRef,
    title: "Enrollment Requirements",
    modal: true,
    onRequestClose: clickXContinueEnrollmentActions,
    "data-testid": "continue-enrollment-dialog",
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      label: "Back",
      "data-testid": "continue-enrollment-back-button",
      onClick: function onClick() {
        return continueEnrollmentModalRef.current.closeDialog();
      }
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: onContinueEnrollment,
      primary: true,
      label: "Continue with enrollment",
      "data-testid": "continue-enrollment-button"
    }))
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "pb-4"
  }, /*#__PURE__*/React.createElement("b", null, "This social care coverage plan has prerequisites for enrollment.")), /*#__PURE__*/React.createElement("p", {
    className: "pb-4"
  }, "Choose \"Continue with enrollment\" to provide the required documentation in order to proceed with the enrollment request."))));
};
SocialInsuranceForm.propTypes = {
  contact: PropTypes.object.isRequired,
  goToEnrollmentWorkflow: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
  networkId: PropTypes.string.isRequired
};
//# sourceMappingURL=SocialInsuranceForm.js.map